const newsListing = document.querySelector( '#news-types' );

if ( newsListing !== null ) {

  document.querySelector( '#news-types' ).addEventListener( 'change', function() {

    let newsType = document.querySelector( '#news-types' ).value;

    if ( newsType === '' ) {

      location.href = ofh_news_url + '#news-listing'

    } else {

      location.href = ofh_news_url + '?news-type=' + newsType + '#news-listing';

    }

  } );

}
